// ADDED: Salary Advance Bracket Module
import React, { useState } from "react";
import SalaryAdvanceDeductionBracketTable from "./components/SalaryAdvanceDeductionBracketTable";
import SalaryAdvanceDeductionBracketAddEditModal from "./components/SalaryAdvanceDeductionBracketAddEditModal";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';

const SalaryAdvanceDeductionBracketModule = ({
  user,
  data,
  loading,
  searchData,
  getBracketById, 
  createBracket,
  updateBracket
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  // MODIFIED: Asynchronous handleEdit to fetch by ID first
  // Note: This will now wait for at least 500ms due to hook logic
  const handleEdit = async (item) => {
    const res = await getBracketById(item.id);
    if (res.success) {
      setSelectedItem(res.data);
      setIsModalOpen(true);
    }
  };

  const handleSearch = (value) => {
    setCurrentPage(1);
    searchData(value);
  };

  const handleSave = async (form) => {
    const apiData = {
      ...form,
      minAmount: Number(form.minAmount) || 0,
      maxAmount: Number(form.maxAmount) || 0,
      deductionAmount: Number(form.deductionAmount) || 0,
      bonusDeductionAmount: Number(form.bonusDeductionAmount) || 0,
      employeeTypeId: Number(form.employeeTypeId)
    };

    if (selectedItem) {
      const audit = [{
        setupArea: "Salary Advance Bracket",
        actionTaken: "update",
        field: "Employee Type",
        newValue: form.employeeTypeDescription,
        oldValue: selectedItem.employeeTypeDescription,
        dateSaved: new Date(),
        savedById: user.id
      }];

      const res = await updateBracket(selectedItem.id, apiData, audit);
      if (res.success) setIsModalOpen(false);
    } else {
      const audit = {
        setupArea: "Salary Advance Bracket",
        actionTaken: "insert",
        field: "Add",
        newValue: `New bracket for ${form.employeeTypeDescription}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createBracket(apiData, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  return (
    <div className='p-4 space-y-4 relative'>
      <div className="flex justify-between items-center">
        <SearchBar handleFilter={handleSearch} />
        <Button
          icon={<AddIcon />}
          name={"Add Bracket"}
          className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
          onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
        />
      </div>

      <SalaryAdvanceDeductionBracketTable
        data={data}
        onEdit={handleEdit}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <SalaryAdvanceDeductionBracketAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />
    </div>
  );
};

export default SalaryAdvanceDeductionBracketModule;